import React, {} from "react";
import Footer from "../Components/Footer";


function PrivacyPolicy() {
  return (
    <div className="w-full h-screen  flex flex-col">
      <div className="px-32 pt-2   flex-1 flex justify-center ">
        <div className="w-2/3">
        <img className="my-8" alt="app icon" src={require("../images/icons/logo.png")} />
          <h1 className="font-bold text-2xl"> Privacy Policy: </h1>
          <p>
          The team behind “Ignite” takes your privacy and data safety very seriously. Please read the privacy 
          policy mentioned below to understand how we adopt a safe data handling practice. We absolutely respect 
          your rights to privacy and always do our best to implement practices that are in the favour of our users.
          </p>

          <ul className="list-disc pl-4">
            <li>
            We respect the fact that your privacy is important. That is why Ignite always ask for your permission before
             you initiate the usage of software or visit our website/product page.

            </li>
            
            <li>
            We may also require your permission anywhere online being operated under the name “Ignite” 
            (with our acknowledgement or referred by us).

            </li>

            <li>
            Your data is only required to ensure the software provides you with a customised and proper experience. 
            Please be rest assured that Ignite will always confirm your consent before collecting data from your usage. 
            </li>

            <li>
            We collect the only data required to make your experience useful. The data we collect is protected to the only 
            extent allowed by commercial means.

            </li>

            <li>
            We also want to notify you that there are some external links provided on our website either by us 
            or our partners that may redirect you to other websites. Ignite does not take any responsibility for 
            the actions you may take outside our website or software. 

            </li>

            <li>
            We ensure you that your data is in safe hands as we never share your data with any third-party vendor 
            or partner excluding the ones you have agreed to. 

            </li>

            <li>
            All businesses may be forced to disclose the users’ data by the local/international law agencies in case 
            they experience any suspicious or malicious activity. Under such circumstances, we may be forced to release your data.

            </li>

            <li>
            Please understand that if you do not consent to Ignite collecting your data, you may experience 
            lags in performance or inefficiency in the features offered by the Ignite. 
            </li>
            
          </ul>

          <p  >
          When you use our software after visiting this agreement, it will be considered as acceptance of this agreement and our terms. 

          </p>
 
        </div>
      </div>
      <div className=" flex-none">
        <Footer/>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
